import React, { useState, useRef, useEffect } from "react";
import logo from "../../../../assets/img/topbar/logo.png";
import { Link } from "react-router-dom";
import "./Sidebar.css";

import { ADMIN_NAV_ITEMS } from "./AdminMenu";
import { canAccess } from "../Utils/rightBasedAccess";

export const AdminSidebar = ({ isSidebarCollapsed }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRefs = useRef({});

  const user = JSON.parse(localStorage.getItem("user"))?.user;
  const role = user?.role_slug;

  const toggleDropdown = (key) => {
    setOpenDropdown((prev) => (prev === key ? null : key));
  };

  const handleClickOutside = (e) => {
    const refs = dropdownRefs.current;

    const clickedInside = Object.values(refs).some(
      (ref) => ref && ref.contains(e.target),
    );

    if (!clickedInside) {
      setOpenDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      id="sidebar"
      className={`sidebar-content ${
        isSidebarCollapsed ? "sidebar-collapsed" : ""
      }`}
    >
      <h5 className="text-center py-3">
        <img src={logo} alt="Logo" />
      </h5>

      <ul className="nav flex-column">
        {ADMIN_NAV_ITEMS.map((item) => {
          if (!canAccess(role, item.roles)) return null;

          // ✅ Dropdown
          if (item.children) {
            return (
              <li
                className="nav-item"
                key={item.key}
                ref={(el) => (dropdownRefs.current[item.key] = el)}
              >
                <span
                  className="nav-link"
                  onClick={() => toggleDropdown(item.key)}
                  style={{ cursor: "pointer" }}
                >
                  <i className={item.icon}></i> {item.label}
                  <i
                    className={`fa-solid fa-angle-${
                      openDropdown === item.key ? "up" : "down"
                    } px-3`}
                  ></i>
                </span>

                <ul
                  className={`dropdown-menu-custom ${
                    openDropdown === item.key ? "expanded" : ""
                  }`}
                >
                  {item.children.map((child) =>
                    canAccess(role, child.roles) ? (
                      <li key={child.to}>
                        <Link to={child.to}>{child.label}</Link>
                      </li>
                    ) : null,
                  )}
                </ul>
              </li>
            );
          }

          // ✅ Normal Link
          return (
            <li className="nav-item" key={item.to}>
              <Link to={item.to}>
                <i className={item.icon}></i> {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
